
import Base from "antd/es/typography/Base";
import { RESOURCE_ROLES, ROLES } from "./constants";
export let authKey = process.env.REACT_APP_AUTHKEY

export const RescScmAdminMember = [RESOURCE_ROLES.PlantSCMMember, RESOURCE_ROLES.Admin];
export const AllRescourceMember = [RESOURCE_ROLES.PlantSCMMember, RESOURCE_ROLES.FinanceUser, RESOURCE_ROLES.CommercialUser, RESOURCE_ROLES.ModuleIncharge, RESOURCE_ROLES.ResourceScrutinizer, RESOURCE_ROLES.SuperAdmin];
export const RescKnowledgeAdminMember = [RESOURCE_ROLES.ModuleIncharge, RESOURCE_ROLES.Admin];
export const RescPlantScrutiAdminMember = [RESOURCE_ROLES.ResourceScrutinizer, RESOURCE_ROLES.PlantSCMMember, RESOURCE_ROLES.Admin];
export const ResourceUpdateMember = [RESOURCE_ROLES.PlantSCMMember, RESOURCE_ROLES.SuperAdmin, ROLES.ItAdmin];

export const BaseURL = process.env.REACT_APP_BASE_URL;
const WebsiteURL = process.env.REACT_APP_WEBSITE_URL;
const client_id = process.env.REACT_APP_CLIENT_ID;
const adb2c_url = process.env.REACT_APP_ADB2C_URL;
const stakeholder_signin_policy = process.env.REACT_APP_STAKEHOLDER_SIGNIN_POLICY;
const admin_signin_policy = process.env.REACT_APP_ADMIN_SIGNIN_POLICY;
const stakeholder_signup_policy = process.env.REACT_APP_STAKEHOLDER_SIGNUP_POLICY;
const user_signup_policy = process.env.REACT_APP_USER_SIGNUP_POLICY;

export const GET_STAKEHOLDER_DOCUMENTS =
    BaseURL + '/registration/v1/StakeHolder/get_all_stakeholder_bank_and_idProof_Documents'

export const ALL_MODULE_ROLES =
    BaseURL + '/registration/v1/User/get_all_modules'

export const MODULES_ROLES_LIST =
    BaseURL + '/registration/v1/User/get_all_modules_with_roles'

export const GET_SIDEBAR_FUNCTIONS_BY_ROLE =
    BaseURL + '/registration/v1/User/get_all_functions_by_role'

export const ADD_GROWER =
    BaseURL + '/registration/v1/Grower/add_grower'

export const GROWER_EXCEL_UPLOAD =
    BaseURL + '/registration/v1/Grower/add_bulk_grower'

export const ADD_TRANSPORTER =
    BaseURL + '/registration/v1/Transporter/add_transporter'

export const ADD_HIT =
    BaseURL + '/registration/v1/Hit/add_hit'

export const ADD_LLE =
    BaseURL + '/registration/v1/Lle/add_lle'

export const GET_GROWER_BY_URN =
    BaseURL + '/registration/v1/Grower/get_grower_by_urn'

export const UPDATE_GROWER =
    BaseURL + '/registration/v1/Grower/update_grower'

export const CHECK_USER_DISTRICT_MAPPING =
    BaseURL + '/registration/v1/Scrutiny/check_user_district_Mapping'

export const CHECK_STATUS =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_registration_status'

export const GET_UNREAD_NOTIFICATION =
    BaseURL + '/master/v1/AppNotification/get_unread_notification'

export const GET_ALL_NOTIFICATION =
    BaseURL + '/master/v1/AppNotification/get_all_notifications'

export const UPDATE_NOTIFICATION_READ_STATUS =
    BaseURL + '/master/v1/AppNotification/update_notification_read_status'

export const GET_ADDRESS_BY_PINCODE =
    BaseURL + '/master/v1/Address/get_address_by_pincode'

export const GET_ADDRESS_BY_IFSC =
    BaseURL + '/master/v1/Bankdetails/get_bankdetails_by_ifsc'

export const UPLOAD_DCUMENT =
    BaseURL + '/document/v1/Blob/upload_document'

export const UPLOAD_EXCEL_DCUMENT =
    BaseURL + '/document/v1/Blob/upload_excel_document'

export const UPDATE_TRANSPORTER =
    BaseURL + '/registration/v1/Transporter/update_transporter'

export const STAKEHOLDER_COUNT =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_count'

export const GET_STAKEHOLDERS_BY_CRITERIA =
    BaseURL + '/registration/v1/StakeHolder/get_all_stakeholders_by_criteria'

export const GET_ALL_STAKEHOLDERS =
    BaseURL + '/registration/v1/StakeHolder/get_all_stakeholders'

export const  SEND_TO_SAP_VENDOR = 
    BaseURL + '/registration/v1/Scrutiny/send_vendor_to_sap'

export const GET_GROWER_BAMBOO_SPECIES =
    BaseURL + '/registration/v1/Grower/get_grower_bamboo_species'

export const GET_TRANSPORTER =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_by_urn'

export const TYPE_COUNT =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_type_count'

export const GET_STAKEHOLDER_BY_URN =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_by_urn'

export const UPDATE_HIT =
    BaseURL + '/registration/v1/Hit/update_hit'

export const CHANGE_PASSWORD =
    BaseURL + '/user/v1/User/change_password'

export const VERIFY_GROWER_MOBILE_NUMBER =
    BaseURL + '/registration/v1/StakeHolder/verify_grower_mobile_number'

//Onboarding Stakeholder

export const SEND_CARD_FOR_PRINTING =
    BaseURL + '/registration/v1/StakeHolder/send_card_for_printing'

export const All_ONBOARD_STAKEHOLDER_ROLE =
    BaseURL + '/registration/v1/User/get_all_roles'

export const SAVE_INTERNAL_STAKEHOLDER =
    BaseURL + '/registration/v1/User/save_user'

export const APPROVE_USER =
    BaseURL + '/registration/v1/User/save_user_approval'

export const GET_USER_APPROVALS =
    BaseURL + '/registration/v1/User/get_all_user_approvals'


export const ADD_SHORTLIST_CRITERIA =
    BaseURL + '/registration/v1/StakeHolder/add_shortlist_criteira'

export const AUTO_SHORTLIST =
    BaseURL + '/registration/v1/StakeHolder/auto_shortlist_stakeholder'

export const ADD_BULK_PINCODE =
    BaseURL + '/registration/v1/StakeHolder/add_bulk_pincodes'

export const GET_USER_DETAILS =
    BaseURL + '/registration/v1/User/get_user_dashboard_details'

export const GET_MAPPING_DETAILS =
    BaseURL + '/registration/v1/Scrutiny/get_scrutinizer_stakeholder_mapping'

export const GET_MAPPING_DETAILS_PAGINATED=
    BaseURL + '/registration/v1/Scrutiny/get_stakeholder_mapping_with_paging'

export const GET_APPLICATION_LIST =
    BaseURL + '/registration/v1/Scrutiny/get_application_list_by_user_status'

export const GET_APPLICATION_COMMENTS =
    BaseURL + '/registration/v1/Scrutiny/get_application_comments'

export const ALLOCATE_WORKFLOW =
    BaseURL + '/registration/v1/Scrutiny/allocate_workflow'

export const UPDATE_LLE =
    BaseURL + '/registration/v1/Lle/update_lle'

export const GET_USER_BY_ROLES =
    BaseURL + '/registration/v1/User/get_user_by_roles'

export const GET_ALL_SCRUTINIZER_LEAD_MAPPING =
    BaseURL + '/registration/v1/Scrutiny/get_all_scrutinizer_lead_mapping'

export const MAP_SCRUTINIZER_TO_LEAD =
    BaseURL + '/registration/v1/Scrutiny/map_scrutinizer_to_lead'

export const GET_SCRUTINIZER_STAKEHOLDER_MAPPING =
    BaseURL + '/registration/v1/Scrutiny/get_scrutinizer_stakeholder_mapping'

export const MAP_STAKEHOLDER_TO_SCRUTINIZER =
    BaseURL + '/registration/v1/Scrutiny/map_stakeholder_to_scrutinizer'

export const SEARCH_STAKEHOLDER_FOR_SCRUTINY =
    BaseURL + '/registration/v1/Scrutiny/search_stakeholders_for_scrutiny'
export const UPDATE_STAKEHOLDER_OID =
    BaseURL + '/registration/v1/StakeHolder/update_stakeholder_ADB2C_oid'
export const UPDATE_USER_OID =
    BaseURL + '/registration/v1/User/update_user_ADB2C_oid'
export const UPDATE_STAKEHOLDER_PHOTO =
    BaseURL + '/registration/v1/StakeHolder/update_stakeholder_photo'
export const GET_STAKEHOLDER_PHOTO =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_photo'
export const CREATE_GUEST_USER =
    BaseURL + '/registration/v1/User/create_guest_user'
export const GET_ALL_SCRUTINIZER_SUPERVISOR_MAPPING =
    BaseURL + '/registration/v1/Scrutiny/get_all_scrutinizer_supervisor_mapping'
export const GET_ALL_UNASSIGNED_SCRUTINIZERS_TO_SUPERVISOR =
    BaseURL + '/registration/v1/User/get_all_unassigned_scrutinizers_to_supervisor'
export const MAP_SCRUTINIZER_TO_SUPERVISOR =
    BaseURL + '/registration/v1/Scrutiny/map_scrutinizer_to_supervisor'
export const GET_SCRUTINIZER_BY_SUPERVISOR_ID =
    BaseURL + '/registration/v1/User/get_scrutinizer_by_supervisorId'
export const VALIDATE_STAKEHOLDER =
    BaseURL + '/registration/v1/StakeHolder/validate_stakeholder'
export const VALIDATE_STAKEHOLDER_OTP =
    BaseURL + '/registration/v1/StakeHolder/validate_stakeholder_mobile'
export const VALIDATE_ABRPL_USER =
    BaseURL + '/registration/v1/User/validate_user'
export const VALIDATE_ABRPL_USER_OTP =
    BaseURL + '/registration/v1/User/validate_user_mobile'
export const FORGOT_PASSWORD =
    BaseURL + '/User/v1/User/forgot_password'

export const INSERT_STAKEHOLDER_COMMENTS =
    BaseURL + '/registration/v1/StakeHolder/insert_stakeholder_comments'

export const GET_STAKEHOLDER_COMMENTS =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholder_comments'

export const GROWER_BULK_UPDATE =
    BaseURL + '/registration/v1/Grower/update_bulk_grower'

export const GET_GROWER_BASIC_DETAILS =
    BaseURL + '/registration/v1/StakeHolder/get_grower_basic_detail_by_urn'

export const INSERT_USER_LOGIN =
    BaseURL + '/registration/v1/User/insert_user_login'
export const UPDATE_USER_LOGOUT =
    BaseURL + '/registration/v1/User/update_user_logout'
export const ACTIVATE_STAKEHOLDERS =
    BaseURL + '/registration/v1/StakeHolder/activate_stakeholders'

export const FETCH_TICKET_STATUS =
    BaseURL + '/helpdesk/v1/fetchTicketStatus'

export const SAVE_USER_DISTRICT_MAPPING = 
    BaseURL + '/registration/v1/Scrutiny/save_user_district_mapping'

export const GET_USER_DISTRICT_MAPPING =
    BaseURL + '/registration/v1/Scrutiny/get_user_district_mapping'

export const INITIATE_WORKFLOW_FOR_REG_SCRU =
    BaseURL + '/registration/v1/Scrutiny/initiate_resource_update_workflow_for_scruitinizer'

{/*Resource Api */ }

export const EDIT_WORKFLOW_REQUEST =
    BaseURL + '/resource/v1/resource/editWorkflowRequest'

export const FETCH_UNMAPPED_AGGREGATOR_ID_RES_LIST =
    BaseURL + "/resource/v1/resource/aggregatorIdRespList "

export const FETCH_HIT_URN_LIST =
    BaseURL + "/resource/v1/resource/aggregator/fetchHITUrnList"

export const FETCH_AGGREGATOR_HIT_MAPPING =
    BaseURL + "/resource/v1/resource/aggregator/fetchAggregatorHitMapping "

export const ADD_AGGREGATOR_HIT_MAPPING =
    BaseURL + "/resource/v1/resource/aggregator/addAggregatorHitMapping "

export const EDIT_AGGREGATOR_HIT_MAPPING_BY_ID =
    BaseURL + "/resource/v1/resource/aggregator/editAggregatorHitMappingById "

export const FETCH_AGGREGATORLIST =
    BaseURL + "/resource/v1/resource/fetchAggregatorList"

export const EDIT_AGGREGATORID =
    BaseURL + "/resource/v1/resource/editAggregatorId"

export const SAVE_AGGREGATORID =
    BaseURL + "/resource/v1/resource/saveAggregatorId"

export const PROVIDE_TRAINING_MATERIAL_CLARIFICATION =
    BaseURL + '/resource/v1/resource/provideTrainingMaterialClarification'

export const FETCH_STAKEHOLDER_RATECARD_STATUS =
    BaseURL + '/resource/v1/resource/fetchStakeholderRateCardStatus'

export const PROVIDE_SEEK_CLARIFICATION_PLANTATION_BATCH =
    BaseURL + '/resource/v1/resource/provideSeekClarificationPlantationBatch'

export const DELETE_RATE_CARD_DOCS =
    BaseURL + '/resource/v1/resource/deleteRatecardDocs'

export const PROVIDE_SEEK_CLARIFICATION_RATE_CARD =
    BaseURL + '/resource/v1/resource/provideSeekClarificationRateCard'

export const FETCHING_BUDGET_APPROVAL_ROLE =
    BaseURL + '/resource/v1/resource/fetchingBudgetApproverRole'

export const FETCH_BUDGET_RANGE_LIST =
    BaseURL + '/resource/v1/resource/fetchBudgetRangeList'

export const EDIT_BUDGET_RANGE =
    BaseURL + '/resource/v1/resource/editBudgetRange'

export const ADD_BUDGET_RANGE =
    BaseURL + '/resource/v1/resource/addBudgetRange'

export const FETCH_USER_LIST =
    BaseURL + '/resource/v1/resource/fetchUserRoleList'

export const FETCH_MATERIAL_LIST =
    BaseURL + '/resource/v1/resource/fetchMaterialList'

export const ADD_MATERIAL_LIST =
    BaseURL + '/resource/v1/resource/addMaterial'

export const EDIT_MATERIAL_LIST =
    BaseURL + '/resource/v1/resource/editMaterial'

export const RATE_CARD_MASS_ENTRY =
    BaseURL + '/resource/v1/resource/uploadMassEntryWithExcel'

export const FETCH_MATURED_DATE =
    BaseURL + '/resource/v1/resource/fetchMaturedDate'

export const WORKFLOW_ACTION_TAKEN =
    BaseURL + '/resource/v1/resource/workflowActionTaken'

export const GROWERS_VACANT_LAND_LIST =
    BaseURL + '/resource/v1/resource/fetchGrowersBasedOnVacateLand '

export const ADD_UPDATE_DELETE_LOV =
    BaseURL + '/resource/v1/resource/addUpdateDeleteLov'

export const CONFIG_MASTER_CONTROLLER =
    BaseURL + '/resource/v1/resource/fetchLovUsingServiceType'

export const GET_ALL_MAPPED_STAKEHOLDER =
    BaseURL + '/resource/v1/resource/getAllStakeHolderDetails'


export const LIST_OF_PROBABLE_MAPPINGS =
    BaseURL + '/resource/v1/resource/listOfProbableMappings'

export const CHECK_MAPPING_EXISTS =
    BaseURL + '/resource/v1/resource/checkMappingExists'

// export const SAVE_RESOURCE_STAKEHOLDER_MAPPING =
//     BaseURL + '/resource/v1/resource/saveResourceStakeholderMapping'
export const SAVE_RESOURCE_STAKEHOLDER_MAPPING =
    BaseURL + '/resource/v1/resource/saveMultipleResourceMapping'

export const ADD_TRAINING_MATERIAL =
    BaseURL + '/resource/v1/resource/addTrainingMaterial'

export const ADD_MULTIPLE_TRAINING_MATERIAL =
    BaseURL + '/resource/v1/resource/saveMultipleTrainingMaterial'

export const GET_PROBABLE_LIST_FOR_STAKEHOLDER_MAPPING =
    BaseURL + '/resource/v1/resource/getProbableListforStakeholderMapping'

export const GET_All_STATE =
    BaseURL + '/master/v1/Address/get_all_States'

export const GET_All_DISTRICT =
    BaseURL + '/master/v1/Address/get_all_Districts'

export const EDIT_RESOURCE_STAKEHOLDER_MAPPING =
    BaseURL + '/resource/v1/resource/editStakeholderMappingById'

export const GET_SHORTLISTING_CRITERIA =
    BaseURL + '/registration/v1/StakeHolder/get_shortlisting_critera'

export const GET_STAKEHOLDERS_FOR_SYSTEM_AUTO_SHORTLIST =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholders_for_system_auto_shortlist'

export const UPDATE_STAKEHOLDER_REGISTRATION_STATUS =
    BaseURL + '/registration/v1/StakeHolder/update_stakeholder_registration_status'

export const SEND_INTIMATION =
    BaseURL + '/registration/v1/Grower/send_pre_reg_intimation'

export const GET_ALL_BLOCKLIST_AND_REVENUECIRCLE =
    BaseURL + '/master/v1/Address/get_All_BlockListsAndRevenueCircle'

export const ADD_RATE_CARD_ITEM =
    BaseURL + '/resource/v1/resource/saveMultipleRateCardItem'

export const GET_ALL_RATE_CARD_BY_CATEGORY_AND_ITEM_TYPE =
    BaseURL + '/resource/v1/resource/getAllRateCardItemByCategoryAndItemType'

export const UPDATE_RATE_CARD =
    BaseURL + '/resource/v1/resource/updateRateCardById'

export const UPDATE_RATE_CONFIRMATION =
    BaseURL + '/resource/v1/resource/updateRateConfirmation'

export const FETCH_RATE_CONFIRMATION_BY_URN =
    BaseURL + '/resource/v1/resource/fetchRateConfirmationByurn'

export const FETCH_ALL_RATE_CONFIRMATION =
    BaseURL + '/resource/v1/resource/fetchAllRateConfirmation'

export const ADD_RATE_CONFIRMATION =
    BaseURL + '/resource/v1/resource/addRateConfirmation'

export const ADD_STORAGE =
    BaseURL + '/registration/v1/TemporaryStorage/add_temporarystorage';

export const GET_WORKFLOW_REQUEST =
    BaseURL + '/resource/v1/resource/getWorkflowRequestList'
export const SEND_OTP = BaseURL + "/notification/v1/Notification/send_otp_sms";
export const VALIDATE_OTP = BaseURL + "/notification/v1/Notification/validate_otp";
export const SEND_SIGNUP_LINK = BaseURL + "/notification/v1/Notification/send_email_without_attachment";

export const GET_LIST_POSSIBLE_ROUTES =
    BaseURL + '/resource/v1/resource/getListPossibleRoute'


export const GET_LIST_ONLY_HIT_DETAILS =
    BaseURL + '/resource/v1/resource/getStakeholdersBasedOnCriteria'

export const GET_LAND_DETAILS_FROM_REGISTRATION_MODULE =
    BaseURL + '/resource/v1/resource/getLandDetailsFromRegistrationModule'

export const GET_DROPDOWN_FOR_PLANTATION_BATCH =
    BaseURL + '/resource/v1/resource/getLovsforPlantation'

export const UPLOAD_PHOTO = BaseURL + '/document/v1/Blob/upload_png_document'

export const ADD_PLANTATION_BATCH = BaseURL + '/resource/v1/resource/addPlantationBatch'

export const GET_WORKFLOW_REQUEST_DETAILS = BaseURL + '/resource/v1/resource/getWorkflowRequestDetails'
export const GET_WORKFLOW_ACTION_TAKEN_REQUEST_DETAILS = BaseURL + '/resource/v1/resource/getWkfOfActionTknRstDetails'
export const GET_STAKEHOLDER_CATEGORY = BaseURL + '/registration/v1/StakeHolder/get_stakeholder_category'

export const FETCH_NEW_PLANTBATCH = BaseURL + '/resource/v1/resource/fetchNewPlantBatch'
export const GET_ALL_PLANTATION = BaseURL + '/resource/v1/resource/getAllPlantationBatch'
export const EDIT_PLANTATION = BaseURL + '/resource/v1/resource/editPlantationBatchById'
export const UPDATE_TEMPORARY_STORAGE = BaseURL + '/registration/v1/TemporaryStorage/update_temporarystorage'
export const DOWNLOAD_DOCUMENT = BaseURL + '/document/v1/Blob/download_document'

export const ALL_TRANSPORTER_NAME =
    BaseURL + '/resource/v1/resource/getAllTransporterDetails'

export const FROM_TO_TRANSPORTER_DROPDOWN =
    BaseURL + '/resource/v1/resource/fromToDropdownForTransporter'

export const GET_ALL_TRAINING_MATERIAL =
    BaseURL + '/resource/v1/resource/getAllTrainingMaterial'

export const FETCH_GROWER_HIT_LLE_ROUTE =
    BaseURL + '/resource/v1/resource/fetchGrowerHitLleRoute'

export const FETCH_GROWER_HIT_IS_ROUTE =
    BaseURL + '/resource/v1/resource/fetchGrowerHitIsRoute'
export const GENERATE_QRCODE =
    BaseURL + '/master/v1/Barcode/generate_qrcode'
export const GET_CARD_INFO =
    BaseURL + '/registration/v1/StakeHolder/get_smart_card_info'

export const FETCH_LLE_TRANSPORTER_PLANT_ROUTE =
    BaseURL + '/resource/v1/resource/fetchLleTransportPlantRoute'

export const FETCH_LLE_TRANSPORTER_IS_ROUTE =
    BaseURL + '/resource/v1/resource/fetchLleTransportIsRoute'

export const FETCH_GROWER_HIT_LLE_TRANSPORTER_PLANT_ROUTE =
    BaseURL + '/resource/v1/resource/fetchGrowerHitLleTransportPlantRoute'

export const SAVE_MULTIPLE_RESOURCE_STAKEHOLDER_MAPPING =
    BaseURL + '/resource/v1/resource/saveMultipleResourceMapping'

export const STAKEHOLDER_MAPPING_VALIDATION =
    BaseURL + '/resource/v1/resource/validationForMapping'

export const ITEM_LIST_BASED_ON_CATEGORY =
    BaseURL + '/resource/v1/resource/fetchItemListBasedOnCategory'

export const PAYMENT_METHOD_LIST =
    BaseURL + '/resource/v1/resource/fetchPaymentMethodList'

export const PAYMENT_CYCLE_LIST =
    BaseURL + '/resource/v1/resource/fetchPaymentCycleList'

export const ADD_PAYMENT_DETAILS =
    BaseURL + '/resource/v1/resource/addPaymentDetails'

export const URN_LIST_BASED_ON_CAT_ITEM =
    BaseURL + '/resource/v1/resource/fetchUrnListBasedOnCatItem'

export const PAYMENT_URN_LIST =
    BaseURL + '/resource/v1/resource/fetchingStakeholderDetails'

export const FETCH_PAYMENT_DETAILS =
    BaseURL + '/resource/v1/resource/fetchPaymentDetails'

export const VIEW_ALL_TRANSPORTER_MAPPED_DETAILS =
    BaseURL + '/resource/v1/resource/viewStakeholderMappingBasedOnRoute'

export const VEHICLE_LIST_BASED_ON_URN =
    BaseURL + '/resource/v1/resource/fetchVehicleListBasedOnTypeUrn'

export const LIST_OF_UNIT_PER_ITEM =
    BaseURL + '/resource/v1/resource/fetchListOfUnitPerItem'

export const SAVE_FELLING_SERIES =
    BaseURL + '/registration/v1/Grower/save_felling_series'

export const GET_FELLING_SERIES =
    BaseURL + '/registration/v1/Grower/get_felling_series'

export const GET_APP_COUNT_STAKE =
    BaseURL + '/registration/v1/Scrutiny/get_application_status_count'

export const GET_ALL_USERS =
    BaseURL + "/registration/v1/User/get_all_users"

export const GET_USER =
    BaseURL + '/registration/v1/User/get_user'

export const PROCESS_WORK_FLOW =
    BaseURL + '/resource/v1/resource/processWorkflowRequestDetails'

export const CRITERIA_BASED_GET_STAKEHOLDER =
    BaseURL + '/resource/v1/resource/getStakeholdersBasedOnCriteria'

export const DELETE_TRAINING_MATERIAL =
    BaseURL + '/resource/v1/resource/deleteTrainingMaterialById'

export const FETCHING_STORAGE_CAPACITY =
    BaseURL + '/resource/v1/resource/fetchAllLlleIsStroageCapacity'

export const FETCHING_ADD_STORAGE_CAPACITY =
    BaseURL + '/resource/v1/resource/fetchLlleIsDetails'

export const ADD_MULTIPLE_STORAGE_CAP =
    BaseURL + '/resource/v1/resource/addMultLlleIsStroageCap'

export const GET_ALL_TRAINING_MATERIAL_BY_CATEGORY =
    BaseURL + '/resource/v1/resource/getTrainingMaterialByCategory'
// export const CRITERIA_BASED_GET_STAKEHOLDER =
//     'https://abeplscm-dev.abepl.co.in/resource/v1/resource/getStakeholdersBasedOnCriteria'
export const GET_AVAILABLE_COUPES = BaseURL + '/registration/v1/Grower/get_available_coupes'

export const CLUMP_LAND_AREA_VALIDATOR =
    BaseURL + '/resource/v1/resource/clumpLandAreaValidator'
export const PROCESS_MULTIPLE_WORK_FLOW =
    BaseURL + '/resource/v1/resource/processMultipleWorkflowRequestDetails'

export const GET_GROWERS_FOR_DBS =
    BaseURL + '/resource/v1/resource/getGrowerForDbs'

export const ADD_GROWERS_FOR_DBS =
    BaseURL + '/resource/v1/resource/addGrowerForDbs'

export const GET_ALL_UNASSIGNED_SCRUTINIZERS =
    BaseURL + '/registration/v1/User/get_all_unassigned_scrutinizers'

export const TOTAL_BAMBOO_GRAPH =
    BaseURL + '/resource/v1/resource/totalBambooGraph'

export const BAMBOO_REGENERATION_GRAPH =
    BaseURL + '/resource/v1/resource/bambooRegenerationGraph'

export const GET_UNMAPPED_SCRUTINIZER =
    BaseURL + '/resource/v1/resource/getUnmappedScrutinizer'

export const GET_ALL_SCM_MEMBER =
    BaseURL + '/resource/v1/resource/getAllSCMmember'

export const ADD_MULTI_SCRUTINZER_SCM_MAPPING =
    BaseURL + '/resource/v1/resource/addMultiScrutinizerSCMmemberMapping'

export const FETCH_SCRUTINIZER_SCM_MAPPING =
    BaseURL + '/resource/v1/resource/fetchScrutinizerSCMmemberMapping'

export const EDIT_SCRUTINIZER_SCM_MAPPED =
    BaseURL + '/resource/v1/resource/editScrutinizerSCMMapped'

export const DELETE_SCRUTINIZER_SCM_MAPPED =
    BaseURL + '/resource/v1/resource/deleteScrutinizerSCMMapped'

export const GET_UNMAPPED_GROWER_SCRUTINIZER =
    BaseURL + '/resource/v1/resource/getUnmappedGrowerWithScrutinizer'

export const GET_ALL_SCRUTINIZER =
    BaseURL + '/resource/v1/resource/getAllScrutinizer'

export const ADD_MULTI_GROWER_SCRUTINIZER_MAPPING =
    BaseURL + '/resource/v1/resource/addMultiGrowerScrutinizerMapping'

export const FETCH_GROWER_SCRUTINIZER_MAPPING =
    BaseURL + '/resource/v1/resource/fetchGrowerScrutinizerMapping'

export const DELETE_GROWER_SCRUTINIZER_MAPPED =
    BaseURL + '/resource/v1/resource/deleteGrowerScrutinizerMapped'

export const SAVE_RATE_CARD_DRAFT =
    BaseURL + '/resource/v1/resource/saveRateCardAsDraft'

export const FETCH_RATE_DRAFT_BY_REQ_NO =
    BaseURL + '/resource/v1/resource/fetchRatedrftByRqstNo'

export const DELETE_DRAFT_DOCS =
    BaseURL + '/resource/v1/resource/deleteRateDraftDocs'

export const DELETE_DRAFT_BY_RQST =
    BaseURL + '/resource/v1/resource/deleteRatedrftByRqstNo'

export const FETCH_UNMAPPED_STAKEHOLDERS =
    BaseURL + '/resource/v1/resource/fetchUnmappedStakeholders'

export const FETCH_NEW_PLANTATION_BATCH =
    BaseURL + '/resource/v1/resource/fetchNewPlantationBatch'

export const ASSIGN_PLANTATION_BATCH =
    BaseURL + '/resource/v1/resource/assignedPlantationBatch'

export const FETCH_ASSIGNED_PLANTATION_BATCH =
    BaseURL + '/resource/v1/resource/fetchAssignedPlantationBatch'

export const FETCH_LLE_URN_LIST =
    BaseURL + '/resource/v1/resource/fetchLLEUrnList'

export const FETCH_GROWER_URN_LIST =
    BaseURL + '/resource/v1/resource/fetchGrowerUrnList'

export const FETCH_STORAGE_LOCATION =
    BaseURL + '/resource/v1/resource/fetchStorageLocation'

export const EDIT_STORAGE_LOCATION =
    BaseURL + '/resource/v1/resource/editStorageLocation'

export const DELETE_STORAGE_LOCATION =
    BaseURL + '/resource/v1/resource/deleteStorageLocation'

export const ADD_STORAGE_LOCATION =
    BaseURL + '/resource/v1/resource/addStorageLocation'

// Demand Planner
export const ADD_ANNUALPLANT =
    BaseURL + '/demand/v1/YearlyInput/add_AnnualPlant'

export const GET_ANNUALDEMAND =
    BaseURL + '/demand/v1/YearlyInput/get_annualDemand'

export const GET_SUGGESTEDRBCBRATIO =
    BaseURL + '/demand/api/Annual/GetSuggestedRbCbRatio'

export const GET_RBCBRATIO =
    BaseURL + '/demand/v1/YearlyInput/get_rbcbratio'

export const SAVE_RBCBRATIO =
    BaseURL + '/demand/v1/YearlyInput/save_RbCbRatio'

export const GET_ANNUALDASHBOARD =
    BaseURL + '/demand/api/Annual/GetAnnualDashboard'

export const GET_ALLHOLIDAY =
    BaseURL + '/demand/v1/YearlyInput/get_allholiday'

export const GET_DEMAND_HOLIDAY =
    BaseURL + '/demand/v1/YearlyInput/get_Demand_Holiday'

export const GET_EXPECTED_DELIVERY_SHORTFALL =
    BaseURL + '/demand/v1/YearlyInput/get_expectedDeliveryShortfall'

export const SAVE_EXPECTED_DELIVERY_SHORTFALL =
    BaseURL + '/demand/v1/YearlyInput/save_expectedDeliveryShortfall'

export const SAVE_HOLIDAY =
    BaseURL + '/demand/v1/YearlyInput/save_Holiday'

export const GET_STAKEHOLDER_BY_TYPE =
    BaseURL + '/registration/v1/StakeHolder/get_stakeholders_by_type'

export const GET_ANNUAL_MBR =
    BaseURL + '/demand/api/Annual/GetAnnualMBR'

export const GET_MONTHLY_MBR =
    BaseURL + '/demand/api/Annual/GetMonthlyMBR'

export const GET_MONTHLY_ALLOCATION =
    BaseURL + '/demand/api/Annual/getMonthlyAllocation'

export const GET_MONTHLY_STAKEHOLDER_ALLOCATION =
    BaseURL + '/demand/api/Annual/getMonthlyStakeholderAllocation'

export const CALCULATE_ANNUAL_DASHBOARD =
    BaseURL + '/demand/api/Annual/calculateAnnualDashboard'

export const LIST_OF_IS_LLE_GROWER =
    BaseURL + '/resource/v1/resource/fetchListOfIsOrLleMappingWithGrower'

export const UPDATE_MONTHLYDEMAND_MONSOONFACTOR =
    BaseURL + '/demand/api/Annual/UpdateMonthlyDemandAndMonsoonFactor'

export const GET_CONSTRAINT =
    BaseURL + '/demand/api/Annual/GetConstraints'

export const CALCULATE_MBR =
    BaseURL + '/demand/api/Annual/CalculateMonthlyMBR'

export const SAVE_SHORTLISTED_STAKEHOLDERS =
    BaseURL + '/demand/api/Annual/SaveShortlistedStakeholders'

export const GET_SHORTLISTED_STAKEHOLDERS =
    BaseURL + '/demand/api/Annual/GetShortlistedStakeholders'

export const CALCULATE_MONTHLY_ALLOCATION =
    BaseURL + '/demand/api/Annual/calculateMonthlyAllocation'

export const FETCH_MAPPINGS =
    BaseURL + '/demand/api/Annual/fetchMappings'

export const GET_MONTHLY_MAPPINGS =
    BaseURL + '/demand/api/Annual/getMonthlyMappings'

export const ADD_BULK_STAKEHOLDER =
    BaseURL + '/demand/v1/YearlyInput/add_bulk_stakeholder'

export const NOTIFY_STAKEHOLDER =
    BaseURL + '/demand/api/Annual/notifyStakeholders'

export const GET_FINANCIAL_YEAR =
    BaseURL + '/demand/api/Annual/GetFinancialYear'

export const ADD_FINANCIAL_YEAR =
    BaseURL + '/demand/api/Annual/AddFinancialYear'

export const GET_PLANNING_NUMBER =
    BaseURL + '/demand/api/Annual/getPlanningNumber'

export const GET_WORKFLOW_LIST =
    BaseURL + '/demand/v1/YearlyInput/get_workflow_list'

export const ALLOCATE_DEMAND_WORKFLOW =
    BaseURL + '/demand/v1/YearlyInput/allocate_workflow'

export const UPDATE_MONTHLY_MBR =
    BaseURL + '/demand/api/Annual/UpdateMonthlyMBR'

export const GET_LLE_CHIPPING_CAPACITY =
    BaseURL + '/demand/api/Annual/getLLEChippingCapacity'

export const GET_LLE_AHP =
    BaseURL + '/demand/api/Annual/getLLEAHP'

export const UPDATE_LLE_AHP =
    BaseURL + '/demand/api/Annual/updateLLEAHP'

export const UPDATE_LLE_CHIPPING_CAPACITY =
    BaseURL + '/demand/api/Annual/updateLLEChippingCapacity'

export const GET_STAKEHOLDER_NOTIFICATION =
    BaseURL + '/demand/api/Annual/getStakeholdersNotification'

export const SAVE_STAKEHOLDER_NOTIFICATION =
    BaseURL + '/demand/api/Annual/SaveStakeholdersNotification'

export const GET_AVG_MOISTURE_PERCENTAGE =
    BaseURL + '/demand/v1/YearlyInput/get_avg_moisture_percentage'

export const GET_SAFETY_STOCK =
    BaseURL + '/demand/api/Annual/getSafetyStock'

export const UPDATE_SAFETY_STOCK =
    BaseURL + '/demand/api/Annual/updateSafetyStock'

export const GET_PAYMENT_DETAILS =
    BaseURL + '/demand/api/Annual/getPaymentDetails'

export const SAVE_PAYMENT_DETAILS =
    BaseURL + '/demand/api/Annual/savePaymentDetails'

export const GET_MONTHLY_ALLOCATION_DASHBOARD =
    BaseURL + '/demand/api/Annual/getMonthlyAllocationDashboard'

export const SAVE_ANNUAL_MBR =
    BaseURL + '/demand/api/Annual/saveAnnualMBR'

export const GENERATE_PO =
    BaseURL + '/pit/v1/PO/generate_po'

export const GET_CONSIGNMENT_CHALLAN_DETAILS =
    BaseURL + '/pit/v1/Device/get_consignment_challan_details'

export const GENERATE_MONTHLY_ALLOCATION =
    BaseURL + '/pit/v1/PO/generate_monthly_allocation'

export const GET_STAKEHOLDER_RATECARD =
    BaseURL + '/demand/api/Annual/getStakeholderRatecard'

export const CALCULATE_IS_MBR =
    BaseURL + '/demand/api/Annual/calculateISMBR'

export const SAVE_MBR_WORKFLOW =
    BaseURL + '/demand/api/Annual/saveMBRWorkflow'

export const CREATE_GROWER_CLUSTER =
    BaseURL + '/demand/api/Annual/CreateGrowerClusters'

export const GET_GROWER_CLUSTER =
    BaseURL + '/demand/api/Annual/GetGrowerCluster'


//PIT APIs ----------
export const RESCHEDULE_BIDDING =
    BaseURL + '/pit/v1/WeeklySchedule/reschedule_bidding'

export const GET_PO_PREVIEW =
    BaseURL + '/pit/v1/PO/get_po_preview'

export const GET_GROWER_INVOICE =
    BaseURL + '/pit/v1/RawBamboo/get_grower_invoice'

export const LIST_OF_VEHICLE = 
    BaseURL + '/pit/v1/Pickup/get_transporter_vehicle_list'

export const RAISE_UNBLOCK_VEHICLE = 
    BaseURL + '/pit/v1/PickUp/raise_unblock_transporter_vehicle_request'     

export const GROWER_PICKUP_NOTIFICATION_ACKNOWLEDGE =
    BaseURL + '/pit/v1/RawBamboo/grower_pickup_notification_acknowledge'

export const GET_ADVANCED_SHIPMENT_DETAILS =
    BaseURL + '/pit/v1/RawBamboo/get_advanced_shipment_detailS'

export const PERMISSIBLE_DEVIATION_CONFIG =
    BaseURL + '/pit/v1/RawBamboo/get_permissible_deviation_config'

export const GET_CONSIGNMENT_NO_TOKEN_NO_BY_URN =
    BaseURL + '/pit/v1/RawBamboo/get_consinement_no_token_no_by_urn'

export const GET_LLE_GROSS_TARE_MEASUREMENT =
    BaseURL + '/pit/v1/RawBambooArrival/get_lle_gross_tare_measurement'

export const GET_SCHEDULE_NO_LIST =
    BaseURL + "/pit/v1/WeeklySchedule/get_schedule_no_list"

export const GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_NO =
    BaseURL + "/pit/v1/WeeklySchedule/get_weekly_schedule_plan_by_schedule_no"

export const GET_CONSIGNMENT_DETAILS_BY_NUMBER =
    BaseURL + "/pit/v1/PickUp/get_consignment_details_by_number"

export const GET_DISTANCE_TRAVELLED =
    BaseURL + "/master/v1/Distance/Get_Distance"

export const GET_AVERAGE_DISTANCE =
    BaseURL + "/pit/v1/PO/get_average_distance"

export const GET_TRANSPORTER_CONSIGNMENT_DATA =
    BaseURL + "/pit/v1/RawBamboo/get_transporter_consignment_data"

export const GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN =
    BaseURL + "/registration/v1/StakeHolder/get_stakeholders_vehicle_driver_by_urn"

export const GET_STAKEHOLDER_BASIC_DETAILS_URN =
    BaseURL + "/registration/v1/StakeHolder/get_stakeholder_basic_details_by_urn"

export const GET_CONSIGNMENT_DATA =
    BaseURL + "/pit/v1/RawBamboo/get_consignment_data"

export const CREATE_CONSIGNMENT =
    BaseURL + "/pit/v1/PickUp/create_consignment"


export const CONSIGNMENT_SAVE =
    BaseURL + "/pit/v1/PickUp/consignment_save"

export const TRIP_START =
    BaseURL + "/pit/v1/PickUp/trip_start"

export const CONSIGNMENT_PICK_UP_SAVE =
    BaseURL + "/pit/v1/PickUp/update_rb_pickup_by_hit"

export const GET_CONSIGNMENT_STATUS_LIST =
    BaseURL + "/pit/v1/PickUp/get_consignment_status"

export const GENERATE_CHIPPING_ORDER =
    BaseURL + "/pit/v1/ChipBamboo/generate_chipping_order"

export const DELETE_CHIPPING_ORDER =
    BaseURL + "/pit/v1/ChipBamboo/delete_chipping_order"

export const DELETE_CHIPPING_ORDER_BUNDLE =
    BaseURL + "/pit/v1/ChipBamboo/delete_chipping_order_bundle"

export const CONSIGNMENT_PICK_UP_CB_SAVE =
    BaseURL + "/pit/v1/PickUp/consignment_pickup_cb_save"

export const CONSIGNMENT_PICK_WEIGHT_MEASUREMENT =
    BaseURL + "/pit/v1/PickUp/consignment_pickup_weight_measurement"

export const UPDATE_LOADING_FLAG =
    BaseURL + "/pit/v1/PickUp/update_source_loading_done_flag"

export const ISSUE_GRN_INVOICE =
    BaseURL + "/pit/v1/RawBambooArrival/issue_grn_and_invoice"

export const UPDATE_PLANT_UNLOADING_DATA =
    BaseURL + "/pit/v1/RawBambooArrival/update_plant_unloading_data"


export const CHIPPING_ORDER_NUMBER_LIST =
    BaseURL + "/pit/v1/ChipBamboo/get_chipping_order_number_list"

export const WEEKLY_SCHEDULE_PLAN_BY_PLANNING_NO =
    BaseURL + "/pit/v1/WeeklySchedule/get_weekly_schedule_plan_by_planning_no"

export const SCHEDULE_PLANNING_NO_LIST =
    BaseURL + "/pit/v1/WeeklySchedule/get_schedule_planning_no_list"

export const PLANT_CONSUMPTION =
    BaseURL + "/pit/v1/ChipBamboo/add_plant_consumption"

export const GET_CHIPPING_ORDER_LIST =
    BaseURL + "/pit/v1/ChipBamboo/get_chipping_order_list"

export const GET_RB_HARVEST_LIST =
    BaseURL + "/pit/v1/PickUp/get_rb_harvest_list"

export const HIT_RB_HARVEST =
    BaseURL + "/pit/v1/PickUp/hit_rb_harvest"

export const GET_INVOICE_DATA_BY_INVOICE_NO =
    BaseURL + "/pit/v1/RawBamboo/get_invoice_data_by_invoice_no"

export const GET_INVOICE_NUMBER_LIST_FOR_SES =
    BaseURL + "/pit/v1/RawBambooArrival/get_invoice_number_list_for_ses"

export const PLANT_ACTUAL_PLANT_CONSUMPTION =
    BaseURL + "/pit/v1/ChipBamboo/add_actual_plant_consumption"

export const GET_CHIPPING_HEAP_NUMBER_LIST =
    BaseURL + "/pit/v1/ChipBamboo/get_chipping_heap_number_list"

export const GET_SUBMITTED_REQUEST_LIST =
    BaseURL + '/resource/v1/resource/getSubmittedRequestList'

export const CHECK_RATE_CARD_VALIDITY_STAKEHOLDER =
    BaseURL + '/resource/v1/resource/validateRateConfirmation'

export const CHECK_RATE_CARD_VALIDITY =
    BaseURL + '/resource/v1/resource/checkRateCardValidity'
export const DELETE_RATE_CARD_BY_ID =
    BaseURL + '/resource/v1/resource/deleteRateCardById'
export const DELETE_PLANTATION =
    BaseURL + '/resource/v1/resource/deletePlantationById'

export const GET_INVOICE_LIST =
    BaseURL + '/pit/v1/RawBamboo/get_invoice_list'

export const GET_GRN_LIST =
    BaseURL + '/pit/v1/Grn/get_grn_list'

export const GET_GRN_LIST_BY_SERVICE_PO =
    BaseURL + '/pit/v1/RawBambooArrival/get_grn_list_by_service_po'

export const GENERATE_SES =
    BaseURL + '/pit/v1/RawBambooArrival/generate_ses'

export const GENERATE_INVOICE =
    BaseURL + '/pit/v1/RawBambooArrival/generate_invoice'

export const GET_PO_LIST =
    BaseURL + '/pit/v1/PO/get_po_list'

export const GET_PO_BY_PO_NUMBER =
    BaseURL + '/pit/v1/PO/get_po_by_po_number'

export const GET_GRN_LIST_FOR_APPROVAL =
    BaseURL + '/pit/v1/Grn/grn_list_for_approval'

export const BULK_APPROVE_GRN =
    BaseURL + '/pit/v1/Grn/bulk_approve_grn'

export const BULK_APPROVE_PO =
    BaseURL + '/pit/v1/PO/bulk_approve_po'

export const GET_DELIVERY_CHALLAN_LIST =
    BaseURL + '/pit/v1/RawBambooArrival/get_delivery_challan_list'

export const GET_DELIVERY_CHALLAN_DETAILS =
    BaseURL + '/pit/v1/RawBambooArrival/get_delivary_challan_by_challan_no'

export const CREATE_DELIVERY_CHALLAN =
    BaseURL + '/pit/v1/RawBambooArrival/create_challan'

export const CHIPPING_ORDER_BY_NUMBER =
    BaseURL + '/pit/v1/ChipBamboo/get_chipping_order_by_order_no'

export const GET_CHIPPING_QUANTITY =
    BaseURL + '/pit/v1/ChipBamboo/get_chipping_quantity'

export const GET_UNRESTRICTED_INVENTORY =
    BaseURL + '/pit/v1/ChipBamboo/get_unrestricted_inventory'


export const GET_ASN_LIST =
    BaseURL + '/pit/v1/RawBambooArrival/get_asn_list'


export const SAVE_QUALITY_INSPECTION =
    BaseURL + '/pit/v1/RawBambooArrival/save_quality_inspection'

export const SEND_TO_QUALITY =
    BaseURL + '/pit/v1/RawBambooArrival/send_to_quality'


export const ISSUE_GRN_AND_INVOICE =
    BaseURL + '/pit/v1/RawBambooArrival/issue_grn_and_invoice'

export const UPDATE_UNLOADING_DATA =
    BaseURL + '/pit/v1/RawBambooArrival/update_unloading_data'

export const GET_MEASUREMENT_LOT_DETAILS_BY_CONSIGNMENT =
    BaseURL + '/pit/v1/RawBambooArrival/get_measurement_lot_details_by_consignment'

export const TRIP_END_READING =
    BaseURL + '/pit/v1/RawBambooArrival/trip_end_reading'

export const UPDATE_UNLOADING_aLLOWED_FLAG =
    BaseURL + '/pit/v1/RawBambooArrival/update_unloading_allowed_flag'

export const COMPLETE_CHIPPING_OPERATION =
    BaseURL + '/pit/v1/ChipBamboo/complete_chipping_operation'

export const CB_CATEGORY_WEIGHT_RATIO_CALCULATION =
    BaseURL + '/pit/v1/ChipBamboo/cb_category_weight_ratio_calculation'

export const UPDATE_CHIPPING_LOCATION =
    BaseURL + '/pit/v1/ChipBamboo/update_chipping_location'

export const TOLERANCE =
    BaseURL + '/quality/quality/v1/fetchQualityToleranceLimitList'

export const GET_CONFIGURATION_VALUES =
    BaseURL + '/pit/v1/RawBambooArrival/get_configuration_values'

export const FETCH_INSPECTION_BY_ID =
    BaseURL + '/quality/quality/v1/fetchingInspectionByOrderId'

export const UPDATE_CONDUCT_INSPECTION_SUBMIT =
    BaseURL + '/quality/quality/v1/updateConductInspSubmit'

export const FETCH_STATUS_DROPDOWN =
    BaseURL + '/quality/quality/v1/fetchStatusDropdown'

export const FETCH_QUALITY_PARAMETER_DROPDOWN =
    BaseURL + '/quality/quality/v1/fetchQualityParameter'

export const PRINT_DOWNLOAD_DATA =
    BaseURL + '/pit/v1/Common/print_download_data'

export const GET_PLANT_INVENTORIES =
    BaseURL + '/pit/v1/ChipBamboo/get_plant_inventories'

export const UPDATE_PLANT_INVENTORIES =
    BaseURL + '/pit/v1/ChipBamboo/update_plant_inventories'


export const GET_BIDDING_SCHEDULE_SELECTION =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_schedule_selection'

export const RELEASE_SCHEDULES_SELECTION_FOR_BIDDING =
    BaseURL + '/pit/v1/WeeklySchedule/release_schedules_selection_for_bidding'

export const GET_APPROVED_SCHEDULEs =
    BaseURL + '/pit/v1/WeeklySchedule/get_approved_schedules'

export const GET_BIDDING_SCHEDULE_APPROVAL =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_schedule_approval'

export const APPROVE_SCHEDULES_FOR_BIDDING =
    BaseURL + '/pit/v1/WeeklySchedule/approve_schedules_for_bidding'

export const APPROVE_REGULAR_SCHEDULES_FOR_BIDDING =
    BaseURL + '/pit/v1/WeeklySchedule/approve_regular_schedule'

export const GET_BIDDING_DETAILS =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_details'

export const ADD_BIDDING_DETAILS =
    BaseURL + '/pit/v1/WeeklySchedule/add_bidding_details'

export const GET_BIDDING_TRANSACTION =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_after_approval'

export const GET_BIDDING_APPROVAL_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_approval_list'

export const ADD_APPROVE_BIDDING_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/approve_bidding_list'

export const GET_INVENTORY_LEDGER_DETAILS =
    BaseURL + '/pit/v1/ChipBamboo/get_inventory_ledger'

export const APPROVE_STAKEHOLDER_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/approve_stakeholder_schedule'

export const GET_WEEK_START_END_DATE =
    BaseURL + '/pit/v1/WeeklySchedule/get_week_start_end_date'

export const GET_CONSIGNMENT_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_consignment_list'

export const GET_SCHEDULE_APPROVAL_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_schedule_approval_list'

export const APPROVE_WEEKLY_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/approve_weekly_schedule'


export const GET_ALL_GROWER_CAPACITY =
    BaseURL + '/resource/v1/resource/getAllGrowersAndCapacity'

export const GET_DASAHBOARD_CONSIGNMENT_LIST =
    BaseURL + '/pit/v1/RawBamboo/get_dashboard_consignment_list'
export const GET_DASHBOARD_INVENTORY_SUM =
    BaseURL + '/pit/v1/ChipBamboo/get_dashboard_inventory_sum'
export const UPDATE_CONSIGNMENT_LOT_DETAILS =
    BaseURL + '/pit/v1/PickUp/update_consignment_lot_details'
export const GET_PLANNING_NUMBER_LIST =
    BaseURL + '/pit/v1/PO/get_Planning_number_list'
export const GET_MANUAL_PO_LIST =
    BaseURL + '/pit/v1/PO/get_manual_po_number_list'
export const GET_PO_LIST_FOR_INVOICE =
    BaseURL + '/pit/v1/PO/get_po_number_list_for_invoice'
export const GET_GROWER_LAND_LIST =
    BaseURL + '/registration/v1/Grower/get_grower_land_list'
export const CREATE_MANUAL_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/create_manual_schedule'
export const GET_OTHER_PLANNING_NUMBER =
    BaseURL + '/pit/v1/PO/get_other_planning_number'
export const FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN =
    BaseURL + '/resource/v1/resource/fetchMappedStakeholderByTypeUrn'
export const GET_DBS_SCHEDULE_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_dbs_schedule_list'
export const CREATE_DBS_ANS =
    BaseURL + '/pit/v1/WeeklySchedule/create_dbs_asn'
export const GET_PO_TAX_CALCULATION =
    BaseURL + '/pit/v1/PO/get_po_tax_calculation'
export const GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO =
    BaseURL + '/pit/v1/PO/get_mapped_grower_po_for_hit_manual_po'
export const CREATE_HIT_MANUAL_PO =
    BaseURL + '/pit/v1/PO/create_hit_manual_po'
export const GET_MAPPED_PLANNING_NUMBER_LIST =
    BaseURL + '/pit/v1/PO/get_mappded_planning_number_list'
export const CREATE_HIT_MANUAL_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/create_hit_manual_schedule'
export const SEND_BACK_FOR_MODIFICATION =
    BaseURL + '/pit/v1/PO/send_back_po_modification'
export const WEIGHBRIDGE_ID_LIST =
    BaseURL + '/pit/v1/RawBambooArrival/get_weighbridge_id_list'
export const WORKFLOW_DASHBOARD =
    BaseURL + '/pit/v1/PO/get_workflow_count'
export const SPLIT_DBS_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/split_dbs_schedule'
export const CREATE_STOCK_TRANSFER_REQUEST =
    BaseURL + '/pit/v1/PO/create_stock_transfer_request'
export const GET_STOCK_TRANSFER_LIST =
    BaseURL + '/pit/v1/PO/get_stock_transfer_list'
export const GET_STOCK_TRANSFER_REQ_BY_ID =
    BaseURL + '/pit/v1/PO/get_stock_transfer_request_by_id'
export const APPROVE_STOCK_TRANSFER_REQUEST =
    BaseURL + '/pit/v1/PO/approve_stock_transfer_request'
export const CREATE_PLANT_CHIPPING_MANUAL_PO =
    BaseURL + '/pit/v1/PO/create_plant_chipping_manual_po'
export const NON_TRANSPORTER_STOCK_TRANSFER = 
    BaseURL + '/pit/v1/PO/non_transporter_stock_transfer'
export const GET_SPOT_BIDDING_REQ_BY_ID =
    BaseURL + '/pit/v1/WeeklySchedule/get_spot_bidding_request_by_id'
export const GET_SPOT_BIDDING_REQ_LIST_FOR_ORDERS =
    BaseURL + '/pit/v1/WeeklySchedule/get_spot_bidding_request_list_for_orders'
export const GET_SPOT_BIDDING_REQ_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_spot_bidding_request_list'
export const APPROVE_SPOT_BIDDING_ALLOTMENT_REQ =
    BaseURL + '/pit/v1/WeeklySchedule/approve_spot_bidding_allotment_request'
export const TRIGGER_BID_NOTIFICATION =
    BaseURL + '/pit/v1/WeeklySchedule/trigger_bid_notifications'
export const CREAT_SPOT_BIDDING_REQUEST =
    BaseURL + '/pit/v1/WeeklySchedule/create_spot_bidding_allotment_request'
export const GET_BIDDINGS_LIST_BY_REQ_NUMBER =
    BaseURL + '/pit/v1/WeeklySchedule/get_biddings_list_by_request_number'
export const ACCEPT_BID_DOCUMENT =
    BaseURL + '/pit/v1/WeeklySchedule/accept_bid_document'
export const SEND_PLANT_GATE_PASS_NOTIFICATION =
    BaseURL + '/pit/v1/PickUp/send_plant_gate_pass_notification'
export const GET_ASN_CORRECTION_LIST = 
    BaseURL + '/pit/v1/RawBambooArrival/get_asn_correction_list'
export const SEND_BACK_ASN_CORRECTION =
    BaseURL + '/pit/v1/RawBambooArrival/send_back_asn_correction'
export const UPDATE_ASN =
    BaseURL + '/pit/v1/RawBambooArrival/update ASN'
export const APPROVE_ASN_CORRECTION =
    BaseURL + '/pit/v1/RawBambooArrival/approve_asn_correction'
export const GET_TRANSPORTER_VEHICLE_LIST =
    BaseURL + '/pit/v1/PickUp/get_transporter_vehicle_list'
export const BLOCK_TRANSPORTER_VEHICLE =
    BaseURL + '/pit/v1/PickUp/block_transporter_vehicle'
export const GET_BLOCKED_TRANSPORTER_VEHICLE_LIST =
    BaseURL + '/pit/v1/PickUp/get_blocked_transporter_vehicle_requests'
export const APPROVE_UNBLOCK_VEHICLE_REQ =
    BaseURL + '/pit/v1/PickUp/aprrove_unblock_transporter_vehicle_request'
export const APPROVE_BLOCK_VEHICLE_REQ =
    BaseURL + '/pit/v1/Pickup/aprrove_block_transporter_vehicle_request'   
export const RAISE_UNBLOCK_TRANSPORTER_VEHICLE_REQ =
    BaseURL + '/pit/v1/PickUp/raise_unblock_transporter_vehicle_request'
export const SEND_GRN_TO_SAP =  
    BaseURL + '/pit/v1/Grn/send_grn_to_sap'
export const SEND_PO_TO_SAP =
    BaseURL + '/pit/v1/PO/send_po_to_sap'
export const DELETE_PO = 
    BaseURL + '/pit/v1/PO/delete_po'
export const EDIT_PO =  
    BaseURL + '/pit/v1/PO/edit_po'
export const REJECT_ASN_CORRECTION =
    BaseURL + '/pit/v1/RawBambooArrival/regect_asn_correction'
export const CALCULATE_TOTAL_INVOICE_BY_GRN_LIST =
    BaseURL + '/pit/v1/RawBambooArrival/calculate_total_invoice_by_grn_list'
export const SEND_SES_TO_SAP =
    BaseURL + '/pit/v1/Grn/send_ses_to_sap'
export const GET_INVOICE_DETAIL_FOR_EDIT=
    BaseURL + '/pit/v1/RawBambooArrival/get_invoice_detail_for_edit'

//....................Payment..................//

export const APPROVE_PAYMENT_INVOICE_REQUEST =
    BaseURL + '/payment/v1/AdvancePayment/approve_payment_invoice_request'

export const PRINT_PAYMENT_DATA =
    BaseURL + '/payment/v1/AdvancePayment/print_payment_data'

export const PRINT_PAYMENT_DATA_EXCEL =
    BaseURL + '/payment/v1/AdvancePayment/print_payment_data_excel'

export const UPDATE_PAID_STATUS =
    BaseURL + '/payment/v1/AdvancePayment/update_paid_status'

export const GET_PARTIALLY_PAID =
    BaseURL + '/payment/v1/AdvancePayment/get_all_invoice_partial_amount_detail'

export const GET_CONFIG_BY_SERVICE_TYPE =
    BaseURL + '/registration/v1/Config/get_config_by_service_type'

export const GET_APPROVED_STAKEHOLDERS =
    BaseURL + '/registration/v1/StakeHolder/get_approved_stakeholders'

export const SAVE_ADVANCE_PAYMENT =
    BaseURL + '/payment/v1/AdvancePayment/save_advance_payment'

export const GET_ALL_PAYMENT_REQUEST =
    BaseURL + '/payment/v1/AdvancePayment/get_all_payment_request'

export const SEND_FOR_PAYMENT_APPROVAL =
    BaseURL + '/payment/v1/AdvancePayment/send_for_payment_approval'

export const CANCEL_PAYMENT =
    BaseURL + '/payment/v1/AdvancePayment/cancel_payment_request'

export const SEND_TO_SAP_FOR_PAYEMENT =
    BaseURL + '/payment/v1/AdvancePayment/send_advance_payment_to_SAP'

export const GET_INVOICE_PAYMENT =
    BaseURL + '/payment/v1/AdvancePayment/get_invoice_payments'
export const GET_INVOICE_PAYMENTS_WITH_PAGING =
    BaseURL + '/payment/v1/AdvancePayment/get_invoice_payments_with_paging'
export const GET_PAYMENT_STATUS =
    BaseURL + '/payment/v1/AdvancePayment/get_payment_status'
export const GET_PAYMENT_STATUS_WITH_PAGING =
    BaseURL + '/payment/v1/AdvancePayment/get_payment_status_with_paging'
export const SEND_INVOICE_PAYMENT_TO_SAP =
    BaseURL + '/payment/v1/AdvancePayment/send_invoice_payment_to_SAP'

export const SEND_LLE_PAYMENT_TO_SAP =
    BaseURL + '/payment/v1/AdvancePayment/send_lle_payment_to_SAP'

export const GET_INVOICE_PAYMENT_BY_GROUP_ID =
    BaseURL + '/payment/v1/AdvancePayment/get_invoice_payments_by_group_id'

export const GET_PAYMENT_PO_LIST =
    BaseURL + '/pit/v1/RawBambooArrival/get_payment_and_po_list'

export const GET_INVOICE_PAYMENTS_BY_URN = 
    BaseURL + '/payment/v1/AdvancePayment/get_invoice_payments_by_urn'

export const GET_STAKEHOLDER_DASHBOARD_PO_DETAILS =
    BaseURL + '/pit/v1/PO/get_stakeholder_dashboard_po_details'

export const CURRENT_RATE =
    BaseURL + '/resource/v1/resource/currentRate'

export const GET_URN_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_urn_no_list'
export const GET_DASHBOARD_COUNT =
    BaseURL + '/pit/v1/RawBamboo/get_dashboard_consignment_count'
export const GET_DASHBOARD_INVENTORY_LIST =
    BaseURL + '/pit/v1/ChipBamboo/get_dashboard_inventory_list'
export const UPDATE_UNLOADING =
    BaseURL + '/pit/v1/RawBambooArrival/update_unloading_flag'
export const GET_SES_LIST =
    BaseURL + '/pit/v1/Grn/get_ses_list'
export const SES_LIST_FOR_APPROVAL =
    BaseURL + '/pit/v1/Grn/ses_list_for_approval'
export const BULK_APPROVE_SES =
    BaseURL + '/pit/v1/Grn/bulk_approve_ses'
export const PIT_INVOICE_ISSUE =
    BaseURL + '/pit/v1/Grn/pit_invoice_issue'
export const GET_TRANSPORTER_BIDDING_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_transporter_bidding_list'
export const APPROVE_INVOICE =
    BaseURL + '/pit/v1/RawBamboo/approve_invoice'
export const REJECT_INVOICE =
    BaseURL + '/pit/v1/RawBamboo/reject_invoice'
export const DELETE_CONSIGNMENT =
    BaseURL + '/pit/v1/PickUp/delete_consignment'
export const UPDATE_CONSIGNMENT =
    BaseURL + '/pit/v1/PickUp/update_consignment'
export const GET_CONSIGNMENT_ISSUE_LIST =
    BaseURL + '/pit/v1/Grn/get_consignment_issue_list'
export const GET_ONHOLD_INVOICE_LIST =
    BaseURL + '/pit/v1/Grn/get_onhold_invoice_list'
export const CLOSE_INVOICE_ISSUE =
    BaseURL + '/pit/v1/Grn/close_invoice_issue'
export const GET_INVENTORY_ISSUE_LIST =
    BaseURL + '/pit/v1/Grn/get_inventory_issue_list'
export const CLOSE_INVENTORY_ISSUE =
    BaseURL + '/pit/v1/Grn/close_inventory_issue'
export const CREATE_MANUAL_PO =
    BaseURL + '/pit/v1/PO/create_manual_po'
export const GET_WEEKLY_SCHEDULE_PLAN_BY_SCHEDULE_ID =
    BaseURL + '/pit/v1/WeeklySchedule/get_weekly_schedule_plan_by_schedule_id'
export const MODIFY_PO =
    BaseURL + '/pit/v1/PO/modify_po'
export const GET_UNLOADER_MAPPING =
    BaseURL + '/pit/v1/RawBambooArrival/get_unloader_mapping'
export const UPDATE_UNLOADER_MAPPING =
    BaseURL + '/pit/v1/RawBambooArrival/update_unloader_mapping'
export const GET_INVENTORY_AVAILABLE_FOR_SCHEDULING =
    BaseURL + '/pit/v1/ChipBamboo/get_inventory_available_for_scheduling'
export const GET_VEHICLE_DETAILS_BY_REG_NO =
    BaseURL + '/pit/v1/PickUp/get_vehicle_details_by_regno'
export const RB_CB_RATIO =
    BaseURL + '/pit/v1/PO/get_rbcbratio'
export const GET_TAX_DETAILS =
    BaseURL + '/pit/v1/PO/get_tax_details'
export const APPROVE_MODIFIED_PO =
    BaseURL + '/pit/v1/PO/approve_modified_po'
export const DELETE_SCHEDULE =
    BaseURL + '/pit/v1/WeeklySchedule/delete_balance_schedule'
export const CREATE_DBS_ASN_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/create_dbs_asn_list'
export const BIDDING_TERM_ACCEPTANCE_REPORT =
    BaseURL + '/pit/v1/WeeklySchedule/get_bidding_term_acceptance_report'
export const GET_ALLOTMENT_REQ_NUMBER_LIST =
    BaseURL + '/pit/v1/WeeklySchedule/get_bid_number_list'
export const GET_PO_REPORT = 
    BaseURL + '/pit/v1/PO/get_po_report'
export const GET_DRIVER_DETAILS_BY_LICENSE_NO =
    BaseURL + '/pit/v1/PickUp/get_driver_details_by_license_no'
export const UPDATE_TRANSPORTER_STATUS_TO_BID =
    BaseURL + '/pit/v1/WeeklySchedule/update_transporter_status_to_bid'
export const GET_CURRENT_INVENTORY_LIST =
    BaseURL + '/pit/v1/ChipBamboo/get_current_inventory_list'
export const RAISE_REQUEST_FOR_CONSIGNMENT_CANCELLATION =
    BaseURL + '/pit/v1/PickUp/raise_request_for_consignment_cancellation'
export const GET_CONSIGNMENT_CANCELLATION_REQUEST_LIST =
    BaseURL + '/pit/v1/PickUp/get_consignment_cancellation_request_list'
export const APPROVE_CONSIGNMENT_CANCELLATION_REQUEST =
    BaseURL + '/pit/v1/PickUp/approve_consignment_cancellation_request'

{/*Quality Api */ }
export const FETCH_WORKLIST =
    BaseURL + '/quality/quality/v1/fetchApprovalTolerenceLimitList'

export const TOLERANCE_APPROVAL =
    BaseURL + '/quality/quality/v1/multipleToleranceApproval'

export const FETCH_MATERIAL_CODE =
    BaseURL + '/quality/quality/v1/fetchQualityMaterialCode'
export const FETCH_INSPECTION_FOR =
    BaseURL + '/quality/quality/v1/fetchQualityInspectionFor'
export const FETCH_GRIEVANCE_NO =
    BaseURL + '/quality/quality/v1/fetchingGrievanceQuality'
export const FETCH_INSPECTIONWORK_ORDER_LIST =
    BaseURL + '/quality/quality/v1/fetchQualityInspectionWorkOrderList'
export const FETCH_ISSUE_NO =
    BaseURL + '/quality/quality/v1/getAllIssueList'
export const FETCH_PIT_INVENTORY_DETAILS =
    BaseURL + '/quality/quality/v1/fetchingPitInventoryDetails'
export const FETCH_MANAGE_TOLERANCE_LIST =
    BaseURL + '/quality/quality/v1/fetchQualityToleranceLimitList'
export const ADD_MANAGE_TOLERANCE_LIST =
    BaseURL + '/quality/quality/v1/saveQualityToleranceLimit'
export const DELETE_MANAGE_TOLERANCE_LIST =
    BaseURL + '/quality/quality/v1/deleteQualityToleranceLimitById'
export const FETCH_MANAGE_TOLERANCE_LIST_BY_ID =
    BaseURL + '/quality/quality/v1/fetchQualityToleranceLimitById'
export const EDIT_MANAGE_TOLERANCE_LIST =
    BaseURL + '/quality/quality/v1/editQualityToleranceLimit'
export const GET_ISSUE_LIST =
    BaseURL + '/quality/quality/v1/getAllIssueList'
export const UPDATE_ISSUE_BY_ID =
    BaseURL + '/quality/quality/v1/updateIssueById'
export const FETCH_INSPECTOR_LIST =
    BaseURL + '/quality/quality/v1/fetchQualityUserDtlList'
export const FETCH_QUALITY_PARAMETER_LIST =
    BaseURL + '/quality/quality/v1/fetchQualityParameter'
export const FETCH_EQUIPMENT_LIST =
    BaseURL + '/quality/quality/v1/fetchQualityInspectionEquipmentList'
// export const ADD_CREATE_INSPECTION =
//     BaseURL + '/quality/quality/v1/createMultipleQualityInspectionOrder'
export const ADD_CREATE_INSPECTION =
    BaseURL + '/quality/quality/v1/addQualityInspectionOrder'
export const FETCH_ISSUE_FROM_ISSUE_NUMBER =
    BaseURL + '/quality/quality/v1/getIssueFromIssueNumber?issueNumber='
export const FETCH_INSPECTION_DETAILS_BY_ID =
    BaseURL + '/quality/quality/v1/fetchingInspectionOrderById'
export const EDIT_INSPECTION_DETAILS_BY_ID =
    BaseURL + '/quality/quality/v1/editQualityInspectionOrderById'
export const FETCH_BY_INSPECTION_CATEGORY =
    BaseURL + '/quality/quality/v1/fetchQualityInspectionCategoryList'

export const UPDATE_WORKLOG =
    BaseURL + '/quality/quality/v1/updateWorklog'

export const CREATE_ISSUE =
    BaseURL + '/quality/quality/v1/createIssue'

export const FETCH_PARA_TOLERANCE_LIMIT =
    BaseURL + '/quality/quality/v1/fetchParaToleranceLimit'
export const FETCH_WORKLOG =
    BaseURL + '/quality/quality/v1/fetchWorklog'

export const GET_ISPECTOR_DETAILS =
    BaseURL + "/quality/quality/v1/fetchQualityUserDtlList"

export const INSPECTION_FETCH_PITDETAILS =
    BaseURL + "/quality/quality/v1/fetchingStakeholderUrn"

export const INSPECTION_FETCH_BUNDLEID_DETAILS =
    BaseURL + "/quality/quality/v1/fetchingBundleDetails"

export const BUNDLES_BY_CON =
    BaseURL + "/quality/quality/v1/fetchingBundlesByCon"

export const INSPECTION_ORDER_GRAPH =
    BaseURL + "/quality/quality/v1/inspectionOrderGraph"

export const ISSUE_ATC_ATC =
    BaseURL + "/quality/quality/v1/issueATCGraph"


export const FEEDBACK_SMS_URL =
    BaseURL + "/notification/v1/Notification/log_sms"




///////////................For Localhost......................////////////
//......................................NOT COMPLETED YET
// export const USER_LOGIN_URL = "https://abrpldev.b2clogin.com/abrpldev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_abrplscm-admin-sign-in&client_id=554e9b52-42ab-4272-8a6f-67a5437d15cf&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F&scope=openid&response_type=id_token&prompt=login";
// export const STAKEHOLDER_LOGIN_URL = "https://abrpldev.b2clogin.com/abrpldev.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_abrplscm-stakeholder-sign-in&client_id=554e9b52-42ab-4272-8a6f-67a5437d15cf&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2F&scope=openid&response_type=id_token&prompt=login";


/////////////.................For DEV......................./////////////
export const STAKEHOLDER_SIGN_UP_URL = adb2c_url + "/oauth2/v2.0/authorize?p=" + stakeholder_signup_policy + "&client_id=" + client_id + "&response_type=code&response_mode=query&prompt=login&state=" + stakeholder_signup_policy + "&redirect_uri=" + WebsiteURL + "&scope=" + client_id + "%20offline_access";
export const USER_LOGIN_URL = adb2c_url + "/oauth2/v2.0/authorize?p=" + admin_signin_policy + "&client_id=" + client_id + "&response_type=code&response_mode=query&prompt=login&state=" + admin_signin_policy + "&redirect_uri=" + WebsiteURL + "&scope=" + client_id + "%20offline_access";
export const STAKEHOLDER_LOGIN_URL = adb2c_url + "/oauth2/v2.0/authorize?p=" + stakeholder_signin_policy + "&client_id=" + client_id + "&response_type=code&response_mode=query&prompt=login&state=" + stakeholder_signin_policy + "&redirect_uri=" + WebsiteURL + "&scope=" + client_id + "%20offline_access";
export const USER_SIGN_UP_URL = adb2c_url + "/oauth2/v2.0/authorize?p=" + user_signup_policy + "&client_id=" + client_id + "&response_type=code&response_mode=query&prompt=login&state=" + user_signup_policy + "&redirect_uri=" + WebsiteURL + "&scope=" + client_id + "%20offline_access";


